import React from 'react'
import { withTransition } from './transitions'
import Title from '../../components/Title'

export default withTransition(function Settings () {
  return <Title>Settings</Title>
})
